import React, { PureComponent } from "react";
import PropTypes from "prop-types";
import onClickOutside from "react-onclickoutside";
import ManagementTools from "../../../../ManagementTools/ManagementTools";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTools, faBook } from "@fortawesome/free-solid-svg-icons";
import { connect } from "react-redux";
import { headerConstants } from "../../../constants";
import { getClientDashboard } from "../../../../../store/reducers/clientDashboard";
import { globals } from '../../../../../globals';
import Analytics from '../../../../../components/Analytics';

const EventTracker = Analytics('Tools Menu');

class HeaderIcons extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      isOpenResources: false,
      isOpenSettings: false,
      enabledColor: false,
    };
    this.toggleColorPallet = this.toggleColorPallet.bind(this);
    this.changeDropDown = this.changeDropDown.bind(this);
    this.openModal = this.openModal.bind(this);
  }

  componentDidMount() {
    this.props.getClientDashboard();
  }

  toggleColorPallet = () => {
    const { enabledColor } = this.state;
    const contentElement = document.querySelector(".content-wrap-body");
    this.setState(
      {
        enabledColor: !enabledColor,
      },
      () => {
        if (!enabledColor) {
          contentElement.classList.add("neutral-pallet");
        } else {
          contentElement.classList.remove("neutral-pallet");
        }
      }
    );
  };

  openUrlInBrowser = (url, title) => () => {
    if (url && url.length !== 0) {
      window.open(url);
      EventTracker('Menu - ' + title);
    }    
  };

  openModal = (id) => () => {
    const { getClientUsers, authData, showModal } = this.props;
    this.setState({ listId: id, activeDropDown: false });
    if (id === "userList") {
      getClientUsers(authData.ClientId);
    }
    showModal(`Management-tools-${id}`);
  };

  renderClientTools = (isActive, authData) => {
    return (
      <div className={`clientTools-dropdown`}>
        <div className={"clienttools-header"}>Tools</div>
        <div className={"clienttools-divider"} />
        {this.props.managementTools.map((item, i) => {
            return (
              <div
                key={i}
                className="clienttools-title" 
                onClick={this.openUrlInBrowser(item.Domain ? globals[item.Domain] + item.Url : item.Url, item.Title)}
              >
                {item.Title}
              </div>
            );
        })}
      </div>
    );
  };

  renderResources = (isActive) => {
    return (
      <div className={`clientResources-dropdown`}>
        <div className={"clientResources-header"}>Resources</div>
        <div className={"clientResources-divider"} />
        {this.props.clientResources.map((item, i) => {
          if (item.GroupUrl) {
            return (
              <div
                key={i}
                className="clientResources-title"
                onClick={this.openUrlInBrowser(item.GroupUrl, item.GroupName)}
              >
                {item.GroupName}
              </div>
            );
          } else
            return [
              <div key={i} className="clientResources-topic">
                {item.GroupName}
              </div>,
              item.Resources.map((item, i) => {
                return (
                  <div
                    key={i}
                    className="clientResources-title ml-3"
                    onClick={this.openUrlInBrowser(item.ResourceUrl, item.ResourceName)}
                  >
                    {item.ResourceName}
                  </div>
                );
              }),
            ];
        })}
      </div>
    );
  };

  handleClickOutside = () => {
    this.setState({ activeDropDown: false });
  };

  changeDropDown = (type) => () => {
    this.setState({ activeDropDown: type });
  };

  render() {
    const { onClick, checkHomeRoute, clientResources, managementTools, messages, authData } = this.props;
    const { activeDropDown } = this.state;
    const { listId } = this.state;

    return (
      <div className="client-header-icons-section noselect">
        <div className="clientResources-block" onClick={this.changeDropDown("clientTools")}>
          <FontAwesomeIcon
            icon={faTools}
            className={`client-header-icons--tools client-header-icons`}
          />
          {this.renderClientTools(activeDropDown, authData)}
        </div>
        <div style={{ width: '14px' }}> </div>
        <div className="clientResources-block" onClick={this.changeDropDown("resources")}>
          <FontAwesomeIcon
            icon={faBook}
            className={`client-header-icons--resources client-header-icons`}
          />
          {this.renderResources(activeDropDown)}
        </div>
        <div style={{ width: '14px' }}> </div>
        <div
          className={`client-default-button ${
            checkHomeRoute ? "pink" : "dark-grey"
          }`}
          onClick={onClick}
        >
          sign out
        </div>
        <ManagementTools listId={listId} />
      </div>
    );
  }

  static propTypes = {
    onClick: PropTypes.func,
    location: PropTypes.string,
    showModal: PropTypes.func,
    authData: PropTypes.object,
    getClientUsers: PropTypes.func,
    checkHomeRoute: PropTypes.bool,
    getClientDashboard: PropTypes.func,
    clientResources: PropTypes.array,
    managementTools: PropTypes.array,
    messages: PropTypes.array,
  };
}

export default connect(
  (state) => ({
    authData: state.auth.authData,
    messages: state.clientDashboard.formDataValue.messages,
    clientResources: state.clientDashboard.formDataValue.clientResources,
    managementTools: state.clientDashboard.formDataValue.managementTools,
  }),
  {
    getClientDashboard,
  }
)(onClickOutside(HeaderIcons));



// WEBPACK FOOTER //
// ./src/components/Header/components/ClientSide/components/HeaderIcons.js